import { _getTrashList } from "@/api";
import { debounce } from "lodash";

const trashPPTList = reactive<any[]>([]);
const paramsConfig = reactive({
  isLoading: false,
  isOver: false,
  page: 1,
  pageSize: 100,
});
const totalPage: Ref<number> = ref(0);

const initPage = () => {
  trashPPTList.splice(0, trashPPTList.length);
  paramsConfig.isLoading = false;
  paramsConfig.isOver = false;
  paramsConfig.page = 1;
  paramsConfig.pageSize = 20;
};

const useTrashPPTList = () => {
  const getTrashPPTList = debounce(async () => {
    try {
      if (paramsConfig.isLoading || paramsConfig.isOver) return;
      paramsConfig.isLoading = true;
      const res: any = await _getTrashList({
        page: paramsConfig.page,
        page_size: paramsConfig.pageSize,
      });
      const data =
        res.data.map((i: any) => {
          return {
            ...i,
            moreActive: false,
            isEdit: false,
          };
        }) || [];
      totalPage.value = res.total;

      trashPPTList.push(...data);
      paramsConfig.isOver =
        paramsConfig.page * paramsConfig.pageSize >= totalPage.value;
      paramsConfig.page++;
    } catch (e: any) {
      console.error(e);
    } finally {
      paramsConfig.isLoading = false;
    }
  }, 200);

  return { getTrashPPTList, paramsConfig };
};

export { trashPPTList, useTrashPPTList, initPage };
